import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { _Api } from "../common/api/_call";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TableColumnModal from "../../components/common/modules/tableColumn";
import { Tablehead } from "../../components/common/modules/Tablehead";
import { poscustomerpayhistory_head } from "../../components/common/Tablehead";
import './customer.scss';
import CheckoutBlank from "../checkout/checkoutBlank";
import { SetdataTable, UnSetdataTable } from "../common/api/setdatatable";
import { useTranslation } from 'react-i18next';
import { toFormatPrice, toUnformatPrice } from '../common/helpers/function';
import { error } from '../common/helpers/toastify';
import TableLoader from '../../admin/common/TableLoader';
import { store } from '../../source/index'
const PaymentHistory = () => {
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  let reduxdata = store.getState()
  let OrgSettings = reduxdata?.app?.posorganisation_settings
  const { t } = useTranslation();
  const { state } = useLocation();
  const [TransactionDate, setTransactionDate] = useState();
  const [newcolumndata, setnewcolumndata] = useState(poscustomerpayhistory_head);
  const [orderlist, setOrderlist] = useState();
  const [showloader, setShowloader] = useState(false)
  const itemdaata = localStorage.getItem("customerdetails")
  const parsedObject = JSON.parse(itemdaata);
  const selectTransactionDate = (input) => {
    setTransactionDate(input);
  };
  useEffect(() => {
    callcolumns();
  }, []);
  const callcolumns = async () => {
    try {
      const postdata = {
        name: "tbl_pos_customerpayhistory",
      };
      let columnhead = await _Api(
        postdata,
        `api/v1/Inventory/common/getColumnHeads`
      );
      if (columnhead.code === 200) {
        setnewcolumndata(columnhead?.data?.data);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const customerspayhistory = async () => {
    setShowloader(true)
    if (!parsedObject?.id) {
      SetdataTable('paymentcustomer_table', '2', newcolumndata, [0]);
      error(t("Customer is Requried!!"));
      return;
    }
    UnSetdataTable('paymentcustomer_table');
    let time = TransactionDate ? new Date(TransactionDate) : null;
    let formattedDate = time ? `${time.getFullYear()}-${(time.getMonth() + 1).toString().padStart(2, '0')}-${time.getDate().toString().padStart(2, '0')}` : null;

    try {
      const postdata = {
        'customer_id': parsedObject?.id,
        // 'date': TransactionDate,
        'type': "PAYMENT",
        "date": formattedDate
      };
      let res = await _Api(postdata, `api/v1/POS/customer/purcahseHistory`);
      if (res.code === 200) {
        SetdataTable('paymentcustomer_table', '2', newcolumndata, [0]);
        setOrderlist(res?.data)
        setShowloader(false)
      } else {
        SetdataTable('paymentcustomer_table', '2', newcolumndata, [0]);
      }
    }
    catch (err) {
      console.log(err, 'err');
    }
  }
  useEffect(() => {
    customerspayhistory()
    // eslint-disable-next-line
  }, [parsedObject?.id, TransactionDate]);
  return (
    <>
      <div className="main-body">
        <div className="main-body-row">
          <div className="main-body-row-left-col p-0">
            <div className="customer">
              <div className='customer-inner'>
                <div className="customer-inner-tophead">
                  <div className=" transactionhistory-heading d-flex gap-3 align-items-center">
                    {state?.navigatename === 'deposit' ?
                      <Link to="/app/pos/receive/deposit" >
                        <img className="transactionhistory-heading-backbtn" src={base_assets + "images/pos/backbtn.png"} alt=""></img></Link>
                      :
                      <Link to="/app/pos/customer/customer" >
                        <img className="transactionhistory-heading-backbtn" src={base_assets + "images/pos/backbtn.png"} alt=""></img></Link>
                    }

                    <h1 className="main-heading">{t("Payment History")}</h1>
                  </div>
                </div>
                <div className="customer-inner-data">
                  <div className='customer-inner-data-payment-table-top-bar'>
                    <div className='customer-inner-data-payment-table-top-bar-left'>
                      <div className='customer-inner-data-payment-table-top-bar-left-multi-select'>
                      </div>
                    </div>
                    <div className='customer-inner-data-payment-table-top-bar-right placeholder-up-input-date date'>
                      <DatePicker
                        className="placeholder-up-input-field"
                        selected={TransactionDate}
                        onChange={selectTransactionDate}
                        name="TransactionDate"
                        dateFormat={OrgSettings?.date_picker}
                        placeholderText='MM/dd/yyyy'
                        autoComplete='none'
                      />
                      <img
                        className="placeholder-up-input-field-calender"
                        src={base_assets + "images/icons/calendar-green.svg"}
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="main-body-main-table-wrap vertical-scroll-table position-relative">
                    <table id="paymentcustomer_table" className="common-table first-row-gray w-100">
                      <Tablehead tablehead={poscustomerpayhistory_head} tblName={"tbl_pos_customerpayhistory"} setfilterby={""} />

                      <tbody>
                        <>
                          {orderlist?.length ? orderlist?.map((result, key) => {
                            return (
                              <tr key={result?.order_id}>
                                <td>{key + 1}</td>
                                <td>{result?.date}</td>
                                <td>{result?.order_type}</td>
                                <td>{result?.order_no}</td>
                                <td>{result?.location}</td>
                                <td>{result?.total_Qty}</td>
                                <td>{toFormatPrice(result?.total_amount, { addSymbol: true })}</td>
                              </tr>
                            );
                          }) : ""}
                        </>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td>{
                            orderlist
                              ? orderlist?.reduce(
                                (interation, val) =>
                                (interation =
                                  interation +
                                  toUnformatPrice(val?.total_Qty)),
                                0
                              )
                              : ""
                          }</td>
                          <td>{toFormatPrice(
                            orderlist
                              ? orderlist?.reduce(
                                (interation, val) =>
                                (interation =
                                  interation +
                                  toUnformatPrice(val?.total_amount)),
                                0
                              )
                              : ""
                            , { addSymbol: true })}</td>
                        </tr>
                      </tfoot>
                    </table>
                    {showloader && <TableLoader />}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="main-body-row-right-col">
            <CheckoutBlank />
          </div>
        </div>
      </div>
      <TableColumnModal tablehead={poscustomerpayhistory_head} tblName={"tbl_pos_customerpayhistory"} setnewcolumndata={setnewcolumndata}
        calldatatable={customerspayhistory}></TableColumnModal>
    </>
  )
}

export default PaymentHistory;